module.exports = "<div id=\"content\">\n\t<div id=\"button-group\">\n\t\t<a href=\"/#/records/create\" class=\"button float-left\">Create record</a>\n\t\t<a href=\"/api/records/download\" class=\"button success float-right\"><i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i> Download all records</a>\n\t</div>\n\n\t<table cellspacing=\"0\" width=\"100%\" datatable=\"\" dt-options=\"recordCtrl.dtOptions\" dt-instance=\"recordCtrl.dtInstance\" dt-columns=\"recordCtrl.dtColumns\">\n\t</table>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/views/html/records/index.html
 ** module id = 35
 ** module chunks = 0
 **/